import script from "./invoice-select-data-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./invoice-select-data-dialog.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__